import { ConfigurationType, ConfigurationView } from '../types/configuration';

export const formatConfigurationValue = (configuration: ConfigurationView): string => {
    switch (configuration.type) {
        case ConfigurationType.BOOLEAN:
            if (!configuration.value) return '-';
            return configuration.value === 'true' ? 'Да' : 'Нет';
        case ConfigurationType.NUMBER:
            return configuration.value || '-';
        default:
            return configuration.value || '-';
    }
};
